<p-tabView>
    <p-tabPanel header="Emails">
        <div class="p-grid">
            <div class="p-col-2">
                <p-panelMenu [model]="itemsEmails" [style]="{'width':'100%'}"  styleClass="w-full md:w-20rem"  [multiple]="false"></p-panelMenu>
            </div>
            <div class="p-col-10">
                <app-template-table [type]="'email'" [moduleId]="moduleId"></app-template-table>
            </div>
        </div>
    </p-tabPanel>
    <!-- <p-tabPanel header="Inventory">
        <div class="p-grid">
            <div class="p-col-2">
                <p-panelMenu [model]="items" [style]="{'width':'100%'}" [multiple]="false"></p-panelMenu>
            </div>
            <div class="p-col-10">
                <app-template-table [type]="'print'"></app-template-table>
            </div>
        </div>
    </p-tabPanel> -->
</p-tabView>



